import { DateTime } from 'luxon';

export default function (date: DateTime, baseDate: DateTime) {
  return date.toRelative({
    base: baseDate,
    unit: ['hours', 'minutes', 'seconds'],
    locale: navigator.language,
  });
}
